import React from 'react';
import CardForm from '../../../../Utils/Cards/CardForm';
import { reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import validate from './validate';
import FlujosFinancierosTable from './FlujosFinancierosTable';
import FlujosInversionTable from './FlujosInversionTable';
import FlujosOperativosTable from './FlujosOperativosTable';
import ResumenTable from './ResumenTable';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { updateComparativoSummaryOnSave } from '../Utils/ComparativoFlujoCajaComponents';

let ComparativoFlujoCajaForm = props => {
    const { handleSubmit, guardarCambios, item, eliminarRegistro, currency, setCurrency, setLoader, allValues, change } = props;

    const handleCurrencyChange = async (event) => {
        const newCurrency = event.target.value;
        setLoader(true);

        setTimeout(() => {
            setLoader(true);
        }, 0);

        setTimeout(async () => {
            await setCurrency(newCurrency);
            await props.changeCurrency(newCurrency, item);
        }, 0);

        setTimeout(() => {
            setLoader(false);
        }, 0);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
        }
    };

    // Función para manejar el submit con actualización de resumen
    const handleFormSubmit = (values) => {
        // Actualizar totales del resumen antes de enviar
        updateComparativoSummaryOnSave(allValues, change);
        
        // Llamar al handleSubmit original
        return handleSubmit(values);
    };

    return (
        <form onSubmit={handleFormSubmit} onKeyDown={handleKeyDown}>
            <div className='col-sm-12 p-0'>
                <CardForm
                    icon="Side_activos/Admin.svg"
                    titulo="COMPARATIVO FLUJO DE CAJA"
                    subtitulo="CONFIGURACIÓN"
                    subtituloForm={guardarCambios ? "EDITAR" : "NUEVO"}
                    col="12"
                    noShadow
                >
                    <div className="mb-3 d-flex align-items-center">
                        <label htmlFor="currency-selector" style={{ marginRight: '10px', marginBottom: '0' }}>Expresado en:</label>
                        <select id="currency-selector" className="form-control custom-select" style={{ width: '180px', border: 'none', outline: 'none', boxShadow: 'none' }} value={currency} onChange={handleCurrencyChange}>
                            <option value="USD">Dólar US$</option>
                            <option value="GTQ">Quetzales (GTQ)</option>
                        </select>
                    </div>

                    <ResumenTable 
                        {...props} 
                        dollar_exchange={item} 
                        eliminarRegistro={eliminarRegistro}
                        allValues={allValues}
                        change={change}
                        currency={currency}
                    />
                    <FlujosOperativosTable 
                        {...props} 
                        dollar_exchange={item} 
                        eliminarRegistro={eliminarRegistro}
                        allValues={allValues}
                        change={change}
                        currency={currency}
                    />
                    <FlujosInversionTable 
                        {...props} 
                        dollar_exchange={item} 
                        eliminarRegistro={eliminarRegistro}
                        allValues={allValues}
                        change={change}
                        currency={currency}
                    />
                    <FlujosFinancierosTable 
                        {...props} 
                        dollar_exchange={item} 
                        eliminarRegistro={eliminarRegistro}
                        allValues={allValues}
                        change={change}
                        currency={currency}
                    />
                </CardForm>
                <div className='buttons-box mt-5'>
                    <button type="submit" className="btn btn-primary m-4 btn-modal">
                        CONFIRMAR
                    </button>
                </div>
            </div>
        </form>
    );
};

ComparativoFlujoCajaForm = reduxForm({
    form: 'ComparativoFlujoCajaForm',
    validate,
})(ComparativoFlujoCajaForm);

// Conectar con Redux para obtener valores del formulario
const formName = 'ComparativoFlujoCajaForm';
const selector = formValueSelector(formName);

const mapStateToProps = (state) => {
    const allValues = selector(state, 'summary', 'operation', 'financial', 'investments') || {};
    return { 
        allValues: {
            summary: allValues.summary || [],
            operation: allValues.operation || [],
            financial: allValues.financial || [],
            investments: allValues.investments || []
        }
    };
};

export default connect(mapStateToProps)(ComparativoFlujoCajaForm);
